import { connectionStationName, connectionStationText } from './connection-station';

type Device = { address?: string; name?: string };
type SavedPrinter = Device & { gateway_id?: string; gateway_name?: string; location_id?: string; status?: string };
type Directory = { printers: SavedPrinter[]; gateways: { id: string; name: string; location_id?: string }[]; locations: { id: string; name: string }[] };
const normalized = (address?: string) => address?.trim().toUpperCase() ?? '';

export function printerIdentityCode(address?: string) {
  return normalized(address).slice(-5);
}
export function savedPrinterAtAddress<T extends SavedPrinter>(printers: T[], address?: string): T | undefined {
  const full = normalized(address);
  return full ? printers.find(printer => normalized(printer.address) === full) : undefined;
}
export function scannedPrinterChoices(devices: Device[], directory: Directory, gatewayId: string) {
  return devices.map(device => {
    const saved = savedPrinterAtAddress(directory.printers, device.address);
    const station = saved && directory.gateways.find(item => item.id === saved.gateway_id);
    const area = saved && directory.locations.find(item => item.id === (saved.location_id ?? station?.location_id));
    const sameStation = !!saved && saved.gateway_id === gatewayId;
    const owner = !saved ? 'Chưa lưu' : sameStation ? 'Đã lưu tại trạm này' :
      `Đã lưu tại ${connectionStationName(station?.name ?? saved.gateway_name)}${area ? ` (${connectionStationText(area.name)})` : ''}`;
    return { address: device.address, saved, rank: sameStation ? 0 : saved ? 1 : 2,
      label: `${saved?.name || device.name || 'Thiết bị không tên'} · ${printerIdentityCode(device.address)} — ${owner}${saved?.status === 'DISABLED' ? ' · Tạm ngừng sử dụng' : ''}` };
  }).sort((a, b) => a.rank - b.rank);
}
